import React, { useState, useEffect, useReducer } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UiTextArea, UiTagInput, UiSelect, UiInput, UiButton, UiRSelect } from "../../ui";
import { useStore } from "../../state.js";
import * as yup from "yup";
import { useNavigate, Link, useParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import DataTable from 'react-data-table-component';
import { AiOutlineClose, AiOutlineSave } from "react-icons/ai";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { toast } from "react-toastify";
import { instance } from "../../axios";
import ImageUploader from "../../components/ImageUploader";
import SortableImageGrid from "../../components/SortableImageGrid";

export default function EntryForm() {
  let { token } = useParams();
  let navigat = useNavigate();
  const defaultImages = []
  const [loader, showLoader] = useState(false);
  const [is_success, setSuccess] = useState(false);
  const [deleted, setDeleted] = useState([]);


  const [images, setImages] = useState(
    defaultImages.map(img => ({
      id: img.id,
      url: img.url
    }))
  );

  const schema = yup.object().shape({
    mobile: yup.string().required("Mobile no. is required").matches(/^[0-9]+$/, "Enter 10 digit mobile number")
      .min(10, "Enter 10 digit mobile number")

      .max(10, "Enter 10 digit mobile number"),

      business_name: yup.string().required("Business name is required"),
      contact_person_name: yup.string().required("Contact person name is required"),
      business_category: yup.string().required("Business category is required"),


  });

  const [state, setState] = useState({});
  var SaveForm = (e) => {
    showLoader(true)
   

    instance({
      method: "post",
      url: "/entry_form",
      data: e,
      headers: { "Content-Type": "application/json" },
    })
      .then(function (response) {
        showLoader(false)
        setState({ ...state, ...response.data })

        if (response.data.login == false) {
          toast(response.data.msg, { type: "error" });
        } else if (response.data.status == "success") {
          setSuccess(true);
        }


      })
      .catch(function (response) { });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    SaveForm(data);

  };
  const fetchData = () => {
    instance
      .get("/get_entry_form.php?token=" + token)
      .then(function (response) {
        if (response.data.status == 'success') {
          setState({ ...state, ...response.data });
          reset({
            mobile: response.data.mobile,
            token: token
          });
        } else {
          toast(response.data.msg, { type: "error" });
          navigat("/add-your-business/", { replace: true });
        }

      })
      .catch(function (error) { })
      .then(function () { });

  }

  const category_w = watch("business_category");

  useEffect(() => {
    fetchData()
  }, []);

  return (

    <div className="pt-4">
      {state && state.status ?
        <>
        {is_success ?
          <div className="text-center">
            <h2 className="mb-3">Your business details have been submitted successfully.</h2>
            <p>We will review your submission and get back to you shortly.</p>
            <Link to="/" className="btn btn-primary mt-4">Go to Home</Link>
          </div>
          :
          <>
          <h2 className="mb-3">Enter business details</h2>
          <div className="p-3 rounded bg-white">


            <form id="entryform" onSubmit={handleSubmit(onSubmitHandler)}>
              <div>
                <UiSelect
                  label="Business Category"
                  name={`business_category`}
                  message={errors.business_category?.message}
                  options={state.category}
                  {...register(`business_category`)}
                />
                <UiInput
                  label="Business Name"
                  type="text"
                  name="business_name"
                  message={errors.business_name?.message}
                  {...register("business_name")}
                />
                <UiInput
                  label="Contact Person Name"
                  type="text"
                  name="contact_person_name"
                  message={errors.contact_person_name?.message}
                  {...register("contact_person_name")}
                />
                <UiInput
                  label="Mobile No."
                  type="number"
                  name="mobile"
                  message={errors.mobile?.message}
                  {...register("mobile")}
                />
                <UiInput
                  label="Email"
                  type="email"
                  name="email"
                  message={errors.email?.message}
                  {...register("email")}
                />
                <UiInput
                  label="Website"
                  type="url"
                  name="website"
                  message={errors.website?.message}
                  {...register("website")}
                />
                <UiInput
                  label="GST No."
                  type="text"
                  name="gst_no"
                  message={errors.gst_no?.message}
                  {...register("gst_no")}
                />
                <UiInput
                  label="IEC No."
                  type="text"
                  name="iec_no"
                  message={errors.iec_no?.message}
                  {...register("iec_no")}
                />
                <UiInput
                  label="Address"
                  type="text"
                  name="address"
                  message={errors.address?.message}
                  {...register("address")}
                />
                <UiInput
                  label="Establishment Year"
                  type="text"
                  name="establishment_year"
                  message={errors.establishment_year?.message}
                  {...register("establishment_year")}
                />
                <div className="row">
                  <div className="col-md-3">
                    <UiSelect
                      label="Area"
                      name={`area`}
                      message={errors.area?.message}
                      options={state.area}
                      {...register(`area`)}
                    />
                  </div>
                  <div className="col-md-3">
                    <UiSelect
                      label="District"
                      name={`district`}
                      message={errors.district?.message}
                      options={state.district}
                      {...register(`district`)}
                    />
                  </div>
                  <div className="col-md-3">
                    <UiSelect
                      label="State"
                      name={`state`}
                      message={errors.state?.message}
                      options={state.state}
                      {...register(`state`)}
                    />
                  </div>
                </div>
              </div>
              {category_w === 'Transport' ?
                <UiSelect
                  label="Transport Specialist"
                  name={`transport_specialist`}
                  message={errors.transport_specialist?.message}
                  options={state.transport_specialist}
                  {...register(`transport_specialist`)}
                />
                : null}
              {['Stone', 'Mining', 'Godown'].includes(category_w) ?
                <>
                  <UiSelect
                    label="Stone Type"
                    name={`stone_type`}
                    message={errors.stone_type?.message}
                    options={state.stone_type}
                    {...register(`stone_type`)}
                  />
                  <Controller
                    name="colors[]"
                    control={control}
                    render={({ field }) => (

                      <UiRSelect
                        {...field}
                        options={state.colors}
                        className="ss"
                        isMulti
                        message={errors.colors?.message}
                        label="Colors"
                      />

                    )}
                  />

                </>
                : null}

              <label className="form-label">Images</label>

              <ImageUploader
                onUploaded={(img) =>
                  setImages(prev => [...prev, img])
                }
              />

              <SortableImageGrid
                images={images}
                setImages={setImages}
                onDelete={(img) => {
                  console.log(img);
                  setDeleted(prev => [...prev, img.id]);

                  setImages(prev =>
                    prev.filter(i => i.id !== img.id)
                  );

                }}
              />
              <input type="hidden" name="token" value={token} {...register("token")} />
              <UiButton className="w-100 btn btn-primary mt-4" title="Submit" />
            </form>
          </div>
        </>}
        </> 
        : null}
    </div>
  );
}
